import moment from "moment";
import { LOCAL_STORAGE } from "../constants/local-storage";

class LocalStorageHelpers {
  static getClientDownloadsDailyCount() {
    const key = LOCAL_STORAGE.clientDailyDownloadsCount;

    // eslint-disable-next-line no-undef
    const rawData = localStorage.getItem(key);
    if (rawData) {
      const data = JSON.parse(rawData);
      if (Date.now() < data.expiresAt) {
        return data.value || 0;
      }
      // eslint-disable-next-line no-undef
      localStorage.removeItem(key);
    }
    return 0;
  }

  static async incrementClientDownloadsDailyCount() {
    const key = LOCAL_STORAGE.clientDailyDownloadsCount;

    // eslint-disable-next-line no-undef
    const rawData = localStorage.getItem(key);
    let value = 0;
    let expiresAt = moment().endOf("day").valueOf();

    if (rawData) {
      const data = JSON.parse(rawData);
      value = (data.value || 0);
      if (Date.now() < data.expiresAt) {
        expiresAt = data.expiresAt;
      }
    }

    // eslint-disable-next-line no-undef
    localStorage.setItem(key, JSON.stringify({ value: value + 1, expiresAt }));
  }
}

export default LocalStorageHelpers;